export const ESAT_MODULE_LABELS = {
  mathematics_1: 'Mathematics 1',
  biology: 'Biology',
  chemistry: 'Chemistry',
  physics: 'Physics',
  mathematics_2: 'Mathematics 2',
};

export const ESAT_OPTIONAL_KEYS = ['biology', 'chemistry', 'physics', 'mathematics_2'];

export function esatModuleLabel(moduleKey) {
  return ESAT_MODULE_LABELS[moduleKey] || moduleKey || '';
}
